import CustomVectorLayer from './CustomVectorLayer';
import { Options } from 'ol/layer/BaseVector';
import { TrackVectorLayerType } from './TrackVectorLayerType';
import { WaypointsEntity } from './WaypointEntity';
import VectorSource from 'ol/source/Vector';
import Point from 'ol/geom/Point';

export default class WaypointLayer extends CustomVectorLayer<VectorSource<Point>> {
    type: TrackVectorLayerType
    waypoint: WaypointsEntity
    constructor(waypoint: WaypointsEntity, type: TrackVectorLayerType, options?: Options<VectorSource<Point>>|undefined) {
        super(options)
        this.waypoint = waypoint
        waypoint.layers.push(this)
        this.type = type
    }
}